import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';

/**
 * Guards the Automation Agents pages. The agentic feature is provisioned on the account,
 * so the check is against the account permissions rather than the user's own permissions.
 */
@Injectable()
export class AutomationAgentsActivateGuard implements CanActivate {
    constructor(
        private currentUserState: CurrentUserStateService,
        private router: Router
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserState.getAccount().pipe(
            filter(account => !!account),
            take(1),
            map(account => {
                const provisioned = account.permissions.includes(userPermissionsEnum.agenticFeature);

                if (!provisioned) {
                    this.router.navigate(['Monitoring']);
                }

                return provisioned;
            })
        );
    }
}
